module.exports = __webpack_public_path__ + "img/IMG_2671_L_BlackMatted_MockedUp.cb2800f5.jpg";